export default __webpack_public_path__ + "edea58a53f9d00c03c7b1c152d121a1e.png";